import PropTypes from "prop-types";
import content from "app-content";

const CurrentPricePrefix = ({ hasMultiplePricesInStock, variantId }) => {
  if (hasMultiplePricesInStock && variantId === null) {
    return <span>{content.saved_items_from_price}</span>;
  }

  return null;
};

CurrentPricePrefix.propTypes = {
  hasMultiplePricesInStock: PropTypes.bool.isRequired,
  variantId: PropTypes.number
};

export default CurrentPricePrefix;
